// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-4f3bbd08]{position:relative}.avatar img[data-v-4f3bbd08]{border:1px solid #dbdbdb}.platform-icon-wrapper[data-v-4f3bbd08]{border-radius:50%;background-color:#fff;border:1px solid #f5f5f5;position:absolute;bottom:-.6rem;right:0;font-size:.8rem;z-index:20}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
